export const getChildRegistersSelector = (state) => state.childRegisters
